import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=108e5b36&"
import script from "./ShareLink.vue?vue&type=script&lang=ts&"
export * from "./ShareLink.vue?vue&type=script&lang=ts&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=108e5b36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports